import axios from 'src/utils/axios';

// SP'ler JSON'u string olarak donduruyor; axios cogu zaman kendisi parse ediyor
// ama content-type text/plain gelirse string kaliyor. Iki durumu da karsiliyoruz.
const coz = (veri, bosDeger) => {
  if (veri === null || veri === undefined || veri === '') return bosDeger;
  if (typeof veri !== 'string') return veri;
  try {
    return JSON.parse(veri);
  } catch {
    return bosDeger;
  }
};

const dizi = veri => {
  const c = coz(veri, []);
  return Array.isArray(c) ? c : [];
};

export const getLookuplar = async () => {
  const { data } = await axios.get('/GetHavcOfferCombos');
  const c = coz(data, {});
  return {
    bayiler: Array.isArray(c.bayiler) ? c.bayiler : [],
    servisler: Array.isArray(c.servisler) ? c.servisler : [],
    durumlar: Array.isArray(c.durumlar) ? c.durumlar : []
  };
};

export const getKatalog = async () => {
  const { data } = await axios.get('/GetHavcOfferCatalog');
  return dizi(data);
};

export const getTeklifler = async ({ bayiId = 0, durum = 0, arama = '' } = {}) => {
  const { data } = await axios.get(
    `/GetHavcOffers/${bayiId || 0}/${durum || 0}/${encodeURIComponent(arama || '')}`
  );
  return dizi(data);
};

export const getTeklifDetay = async teklifId => {
  const { data } = await axios.get(`/GetHavcOfferDetail/${teklifId}`);
  const detay = coz(data, null);
  if (!detay) return null;
  return { ...detay, Kalemler: Array.isArray(detay.Kalemler) ? detay.Kalemler : [] };
};

export const teklifKaydet = async model => {
  const { data } = await axios.post('/SetHavcOffer', {
    TeklifId: model.TeklifId || 0,
    ProjeAdi: model.ProjeAdi,
    MusteriAdSoyad: model.MusteriAdSoyad,
    MusteriTelefon: model.MusteriTelefon,
    MusteriAdres: model.MusteriAdres,
    BayiId: model.BayiId,
    ServisId: model.ServisId,
    Durum: model.Durum || 1,
    GecerlilikGun: Number(model.GecerlilikGun) || 15,
    ParaBirimi: model.ParaBirimi || 'TRY',
    DovizKuru: Number(model.DovizKuru) || 1,
    SarfMalzemeOrani: Number(model.SarfMalzemeOrani) || 0,
    IndirimOrani: Number(model.IndirimOrani) || 0,
    KdvOrani: Number(model.KdvOrani) || 0,
    Sartlar: model.Sartlar,
    // Birim fiyat gonderilmiyor; SP katalogdan okuyor.
    Kalemler: (model.Kalemler || [])
      .filter(k => k.KalemId)
      .map(k => ({ KalemId: k.KalemId, Miktar: Number(k.Miktar) || 0 }))
  });
  return coz(data, { Basarili: true });
};

/** Teklif formu PDF'ini indirir. Dosya adini sunucu Content-Disposition ile veriyor. */
export const teklifPdfIndir = async (teklifId, teklifNo) => {
  const cevap = await axios.get(`/GetHavcOfferPdf/${teklifId}`, { responseType: 'blob' });

  const url = window.URL.createObjectURL(new Blob([cevap.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${teklifNo || `Teklif-${teklifId}`}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 5000);
};

export const teklifSil = async teklifId => {
  const { data } = await axios.get(`/DeleteHavcOffer/${teklifId}`);
  return coz(data, { Basarili: true });
};

/** Toplamlar SP tarafinda da hesaplaniyor; bu ekrandaki anlik onizleme icin. */
export const toplamlariHesapla = (teklif, katalog = []) => {
  const kalemler = teklif?.Kalemler || [];

  const araToplam = kalemler.reduce((acc, satir) => {
    const k = katalog.find(x => x.Id === satir.KalemId);
    const birimFiyat = k ? Number(k.BirimFiyat) : Number(satir.BirimFiyat) || 0;
    return acc + birimFiyat * (Number(satir.Miktar) || 0);
  }, 0);

  const sarf = araToplam * ((Number(teklif?.SarfMalzemeOrani) || 0) / 100);
  const indirimOncesi = araToplam + sarf;
  const indirim = indirimOncesi * ((Number(teklif?.IndirimOrani) || 0) / 100);
  const kdvMatrahi = indirimOncesi - indirim;
  const kdv = kdvMatrahi * ((Number(teklif?.KdvOrani) || 0) / 100);

  return { araToplam, sarf, indirim, kdvMatrahi, kdv, genelToplam: kdvMatrahi + kdv };
};
